// extracted by mini-css-extract-plugin
module.exports = {"footer_simple":"FooterSimple_footer_simple__nBQJy"};